<template>
	<div>
		<p>
			Verantwortlich für die vorliegende Onlinepräsentation der Jugendreferate
			Allgäu-Oberschwaben:
		</p>
		<p>Amelie Widenhorn</p>
		<h3>Anschrift</h3>
		<p class="mb-6">
			Katholisches Jugendreferat Ravensburg
			<br />
			Eisenbahnstr. 2588212 Ravensburg
			<br />
			Tel Jugendreferat: 0751 21881
			<br />
			<a href="mailto:jugendreferat-rv@bdkj-bja.drs.de">
				jugendreferat-rv@bdkj-bja.drs.de
			</a>
		</p>
		<h3>Das Impressum gilt auch für folgende Social Media Profile:</h3>
		<p>
			Facebook:
			<br />
			<a
				href="https://www.facebook.com/Katholische-Jugendreferate-BDKJ-Dekanatsstellen-Ravensburg-Leutkirch-544572582383111/?modal=suggested_action"
			>
				https://www.facebook.com/Katholische-Jugendreferate-BDKJ-Dekanatsstellen-Ravensburg-Leutkirch-544572582383111/?modal=suggested_action
			</a>
			<br />
			Instagram:
			<br />
			<a href="https://www.instagram.com/propellerfestival/">
				https://www.instagram.com/propellerfestival/
			</a>
			<br />
		</p>
		<h3>Gestaltungskonzept, Design und technische Umsetzung</h3>
		<p class="mb-6">
			B|FACTOR | Medienmacher für soziale Themen, Stuttgart
			<br />
			<a href="https://www.bfactor.de">www.bfactor.de</a>
		</p>
		<h3>Haftungsausschluss</h3>
		<p>
			Unser Angebot umfasst Verweise (Links) zu anderen Angeboten im Internet.
			Das Landgericht (LG) Hamburg hat in einem Urteil vom 12. Mai 1998 (Az.:
			312 O 85/98) entschieden, dass die Anbringung eines Links dazu führen
			kann, dass der Verlinkende die Inhalte der Seite, auf die er verlinkt,
			ggf. mit zu verantworten hat, es sei denn, er schließt diese Verantwortung
			ausdrücklich aus. Auch wenn wir bestrebt sind, stets inhaltlich
			unbedenkliche Links anzubieten, erklären wir hiermit, dass wir für die
			Inhalte der verlinkten Websites keine Verantwortung übernehmen und uns
			diese nicht zu eigen machen. Diese Erklärung gilt für alle auf dieser
			Website angebrachten Links. In keinem Fall sind wir verantwortlich für die
			Inhalte von Internetseiten, die auf uns verweisen. Wir sind auch nicht in
			der Lage, Verweise auf uns festzustellen oder zu überprüfen.Wir haben
			ferner keinen Einfluss darauf, wie die hier angebotenen Informationen vom
			Nutzer verwendet, weitergegeben oder verändert weitergegeben werden und
			können daher für entstandene Schäden, entgangene Vorteile oder sonstige
			mittelbare oder unmittelbare Folgen, welche aus der Nutzung der hier
			angebotenen Informationen entstehen, nicht haftbar gemacht werden.
		</p>
		<h3>Datenschutzerklärung</h3>
		<p>
			Der Schutz der Privatsphäre bei der Verarbeitung persönlicher Daten ist
			für uns sehr wichtig und selbstverständlich. Wir verarbeiten persönliche
			Daten, die beim Besuch unserer Website erhoben werden, gemäß den
			gesetzlichen Bestimmungen. bdkj.info erhebt und speichert automatisch in
			ihren Server Log Files Informationen, die ihr Internet-Browser an uns
			übermittelt. Diese Daten für die Webstatistik sind nicht bestimmten
			Personen zuordenbar und dienen der Evaluierung des Angebots. Eine
			Zusammenführung dieser Daten mit anderen Datenquellen findet nicht statt.
			Persönliche Daten werden nur dann gespeichert, wenn dies vom Nutzer selbst
			vorgenommen wird, zum Beispiel im Zuge einer Kontaktaufnahme per Formular.
		</p>
		<NuxtLink to="/datenschutz">Mehr Infos zum Datenschutz</NuxtLink>
	</div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
